import * as Yup from 'yup';


// Filtros form
export interface IfiltrosForm {
    nombres: string,
    apellidos: string,
    estado: string,
    perfil: string,
    usuarioAsignadoId: string
    identificacion: string
}

export const setValoresInicialesNuevoMaestro =  {
        nombres: "",
        apellidos: "",
        estado: "",
        perfil: "",
        usuarioAsignadoId: "",
        identificacion: ""
};


export const esquemaDeValidacionMaestro = Yup.object({
});


// Valores iniciales

export interface IexportarMatrizForm {
    aspiranteEstado: string,
    fechaInicial: string,
    fechaFinal: string,
}

export const valoresInicialesExportarMatriz: IexportarMatrizForm = {
    aspiranteEstado: "",
    fechaInicial: "",
    fechaFinal: "",
}

export const esquemaDeValidacionExportarMatriz = Yup.object({
    aspiranteEstado: Yup.string().required("El estado es obligatorio"),
    fechaInicial: Yup.string().required("La fecha inicial es obligatoria"),
    fechaFinal: Yup.string().required("La fecha final es obligatoria"),
});
